import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a63d4a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "info column" }
const _hoisted_5 = { class: "list-item" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "info column"
}
const _hoisted_9 = { class: "info column" }
const _hoisted_10 = {
  key: 1,
  class: "arrows"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: 
          _ctx.exhibition.image !== null &&
          (_ctx.exhibition.image.medium !== null ||
            _ctx.exhibition.image.original !== null)
            ? _ctx.exhibition.image.medium || _ctx.exhibition.image.original
            : require('@/assets/imgs/avatar.png')
        ,
          alt: _ctx.exhibition.title
        }, null, 8, _hoisted_3),
        _createElementVNode("h3", null, _toDisplayString(_ctx.exhibition.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          (_ctx.exhibition.active)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Online"))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "Offline"))
        ])
      ]),
      (_ctx.draggable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_v_icon, {
              icon: "mdi-delete",
              style: {"color":"white","background-color":"black","padding":"1rem","cursor":"pointer"},
              onClick: _ctx.deleteShow
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          class: "link",
          to: `/shows/${_ctx.exhibition.id}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Edit Show ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.draggable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_v_icon, {
              icon: "mdi-arrow-up-bold",
              onClick: _ctx.moveUp
            }, null, 8, ["onClick"]),
            _createVNode(_component_v_icon, {
              icon: "mdi-arrow-down-bold",
              onClick: _ctx.moveDown
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_divider)
  ], 64))
}